import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white pt-16 pb-8" data-id="element-153">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-154">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-155">
          {/* Brand Info */}
          <div data-id="element-156">
            <h3 className="text-2xl font-bold mb-6" data-id="element-157">Limitless Taekwondo</h3>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-158">
              Building confidence, discipline, and character through martial
              arts in Brighton, Michigan. Family-focused and female-led.
            </p>
            <div className="flex space-x-4" data-id="element-159">
              <a href="https://www.facebook.com/Limitlessmartialart/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-accent transition-colors" aria-label="Facebook" data-id="element-160">
                <Facebook className="h-6 w-6" data-id="element-161" />
              </a>
              <a href="https://instagram.com/LimitlessMA" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-accent transition-colors" aria-label="Instagram" data-id="element-162">
                <Instagram className="h-6 w-6" data-id="element-163" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-164">
            <h4 className="text-lg font-semibold mb-6" data-id="element-165">Quick Links</h4>
            <ul className="space-y-4" data-id="element-166">
              <li data-id="element-167">
                <Link to="/" className="text-gray-400 hover:text-white transition-colors" data-id="element-168">
                  Home
                </Link>
              </li>
              <li data-id="element-169">
                <Link to="/programs" className="text-gray-400 hover:text-white transition-colors" data-id="element-170">
                  Programs
                </Link>
              </li>
              <li data-id="element-171">
                <Link to="/schedule" className="text-gray-400 hover:text-white transition-colors" data-id="element-172">
                  Schedule
                </Link>
              </li>
              <li data-id="element-173">
                <Link to="/staff" className="text-gray-400 hover:text-white transition-colors" data-id="element-174">
                  Staff
                </Link>
              </li>
              <li data-id="element-175">
                <Link to="/gallery" className="text-gray-400 hover:text-white transition-colors" data-id="element-176">
                  Gallery
                </Link>
              </li>
              <li data-id="element-177">
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors" data-id="element-178">
                  About Us
                </Link>
              </li>
              <li data-id="element-179">
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-180">
                  Contact
                </Link>
              </li>
              <li data-id="element-181">
                <Link to="/trial" className="text-accent hover:text-accent-light font-medium transition-colors" data-id="element-182">
                  4-Week Trial
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-183">
            <h4 className="text-lg font-semibold mb-6" data-id="element-184">Contact Us</h4>
            <ul className="space-y-4" data-id="element-185">
              <li className="flex items-start" data-id="element-186">
                <MapPin className="h-5 w-5 text-accent mr-3 mt-1 flex-shrink-0" data-id="element-187" />
                <span className="text-gray-400" data-id="element-188">
                  1363 S. Old US 23
                  <br data-id="element-189" />
                  Brighton, Michigan 48114
                </span>
              </li>
              <li className="flex items-center" data-id="element-190">
                <Phone className="h-5 w-5 text-accent mr-3 flex-shrink-0" data-id="element-191" />
                <a href="tel:8107753153" className="text-gray-400 hover:text-white transition-colors" data-id="element-192">
                  (810) 775-3153
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div data-id="element-193">
            <h4 className="text-lg font-semibold mb-6" data-id="element-194">Class Hours</h4>
            <ul className="space-y-2 text-gray-400" data-id="element-195">
              <li className="flex justify-between" data-id="element-196">
                <span data-id="element-197">Mon - Thu</span>
                <span data-id="element-198">4:00 PM - 8:30 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-199">
                <span data-id="element-200">Friday</span>
                <span data-id="element-201">4:00 PM - 7:30 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-202">
                <span data-id="element-203">Saturday</span>
                <span data-id="element-204">9:00 AM - 12:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-205">
                <span data-id="element-206">Sunday</span>
                <span data-id="element-207">Closed</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-500 text-sm" data-id="element-208">
          <p data-id="element-209">
            &copy; {new Date().getFullYear()} Limitless Taekwondo. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}